'use strict';

/**
 * Maps GA4 gift card analytics (Cart-AddGiftCard) to legacy addToCart payload for Flutter.
 * @param {Object} analyticsData
 * @returns {Object|null}
 */
function buildAddToCartPayload(analyticsData) {
    var items = analyticsData && analyticsData.ecommerce && analyticsData.ecommerce.items;
    if (!items || !items.length) {
        return null;
    }

    var item = items[0];
    return {
        ecommerce: {
            currencyCode: analyticsData.ecommerce.currency || 'EUR',
            add: {
                products: [{
                    name: item.item_name,
                    id: item.item_id,
                    SKU: item.item_sku || item.item_id,
                    price: item.price,
                    brand: item.item_brand,
                    category: item.item_category,
                    variant: item.item_variant,
                    quantity: item.quantity || 1
                }]
            }
        }
    };
}

module.exports = {
    buildAddToCartPayload: buildAddToCartPayload
};
